import { defineMessages } from 'react-intl';

const scope = 'app.workspace.knowledge';

export default defineMessages({
  Template: {
    id: `${scope}.Template`,
    defaultMessage: 'Template',
  },
  Information: {
    id: `${scope}.Information`,
    defaultMessage: 'Information',
  },
});
